export default [
  {
    path: "warehouse/transfer/order/index",
    name: "TransferOrderIndex",
    component: () => import("@/pages/Warehouse/Transfer/OrderIndex.vue"),
    meta: {
      title: "跨仓调拨单",
      requireAuth: true,
    },
  },
  {
    path: "warehouse/transfer/pack/list",
    name: "TransferPackList",
    component: () => import("@/pages/Warehouse/Transfer/PackList.vue"),
    meta: {
      title: "跨仓调拨包裹列表",
      requireAuth: true,
    },
  },
  {
    path: "warehouse/transfer/order/edit",
    name: "TransferOrderEdit",
    component: () => import("@/pages/Warehouse/Transfer/OrderEdit.vue"),
    meta: {
      title: "创建调拨单",
      requireAuth: true,
    },
  },
  {
    path: "warehouse/transfer/pack/detail/:id",
    name: "TransferPackDetail",
    component: () => import("@/pages/Warehouse/Transfer/PackDetail.vue"),
    meta: {
      title: "跨仓调拨包裹明细",
      requireAuth: true,
    },
  },
  {
    path: "warehouse/transfer/order/detail",
    name: "TransferOrderDetail",
    component: () => import("@/pages/Warehouse/Transfer/OrderDetail.vue"),
    meta: {
      title: "调拨单详情",
    },
  },
  {
    path: "warehouse/transfer/transit/goods",
    name: "TransferTransitGoods",
    component: () => import("@/pages/Warehouse/Transfer/TransitGoods.vue"),
    meta: {
      title: "跨仓调拨在途商品明细",
      requireAuth: true,
    },
  },
  {
    path: "warehouse/transfer/enterStore",
    name: "TransferEnterStore",
    component: () => import("@/pages/Warehouse/Transfer/EnterStore.vue"),
    meta: {
      title: "跨仓调拨入库",
      requireAuth: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/warehouseTransfer.js